import { csrfHeader } from '~/utils/csrf'
import { responseAsJSON } from '~/utils/json'

const jsonHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}

export function getJSON(url, headers = {}) {
  const abortController = new AbortController()
  const fullUrl = new URL(url, document.location).toString()

  const options = {
    signal: abortController.signal,
    method: 'GET',
    headers: { ...csrfHeader(), ...jsonHeaders, ...headers },
  }

  const request = fetch(fullUrl, options).then(responseAsJSON)

  return { request, abortController }
}
